import { timeout } from "@/lib/util";
import $ from "jquery";

// Behandelt die ?modal= URLs und simuliert einen Click auf das entsprechende Normblatt
(async () => {
	// Fischt den Parameter "modal" aus dem Querystring raus
	// https://regexr.com/77e50
	let modal = location.search.match(/modal=(.*?)(&|$)/)?.[1];

	if (!modal) return;

	let norm = $("[data-friendly-url]")
		.toArray()
		.find((el) => $(el).data("friendly-url") == modal);

	if (!norm) return;

	// Restlichem Code genug Zeit geben, um den Click Handler zu registrieren
	await timeout(100);

	norm.click();
})();
